<template>
  <div class="routerComponent">
    <div class="contents">
      <div class="title">{{ title }}</div>
    </div>
    <div v-if="title === 'Webhook'">
      <router-link
          :to="{
          name: 'detail',
          params: {
            id: 'Webhook',
            pilot: 'ユーザー',
          },
          hash: '#Webhook-Limitations',
        }"
          style="color: #4c4c4c; text-decoration: none"
      >
        <div class="way">Webhookの制限事項</div>
      </router-link>
      <router-link
          :to="{
          name: 'detail',
          params: {
            id: 'Webhook',
            pilot: 'ユーザー',
          },
          hash: '#Webhook-Payload',
        }"
          style="color: #4c4c4c; text-decoration: none"
      >
        <div class="way">Webhookのペイロード</div>
      </router-link>
      <router-link
          :to="{
          name: 'detail',
          params: {
            id: 'Webhook',
            pilot: 'ユーザー',
          },
          hash: '#Webhook-Event-Triggers',
        }"
          style="color: #4c4c4c; text-decoration: none"
      >
        <div class="way">Webhookのイベントトリガー</div>
      </router-link>
    </div>
    <div class="contents">
      <div class="way">方式</div>
    </div>
    <div v-for="(data, index) in parsed" :key="index">
      <div class="data contents" v-for="ref in data.methods">
        <router-link
            :to="{
            name: 'detail',
            params: {
              id: data.refValue[ref].tags[0],
              pilot: pilot,
            },
            hash: '#' + data.refValue[ref].summary,
          }"
            style="color: #4c4c4c; text-decoration: none"
        >
          <div
              class="content__left"
              v-if="ref === 'get'"
              style="color: #1c4dac; font-weight: 400"
          >
            {{ ref }}
          </div>
          <div
              class="content__left"
              v-if="ref === 'post'"
              style="color: #2e8540; font-weight: 400"
          >
            {{ ref }}
          </div>
          <div
              class="content__left"
              v-if="ref === 'put'"
              style="color: #95507c; font-weight: 400"
          >
            {{ ref }}
          </div>
          <div
              class="content__left"
              v-if="ref === 'delete'"
              style="color: #cc3333; font-weight: 400"
          >
            {{ ref }}
          </div>
          <div class="content__right">
            {{ data.refValue[ref].summary }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RouterComponent',
  props: {
    pilot: String,
    title: String,
    parsed: Array,
  },
};
</script>

<style scoped lang="scss">
.routerComponent {
  font-family: Meiryo, sans-serif;
  font-size: 1.25em;
  display: inline-block;
  box-sizing: border-box;
  padding: 3rem 1.8rem 1rem 1.8rem;
  width: 100%;
  //width: 30%;
}

.title {
  font-weight: 700;
  color: #3c3f42;
  font-family: 'arial', 'Meiryo', 'MS PGothic', sans-serif !important;
  font-size: 1.3em;
}

.way {
  color: #485156;
  line-height: 1.9;
  padding-top: 8px;
}

a:hover {
  background-color: transparent;
  text-decoration: underline;
}

.contents {
  width: 100%;

  .content__left {
    display: inline-block;
    text-align: left;
    padding-right: 3px;
    font-size: 0.95em;
    line-height: 2;
    width: 14%;
  }

  .content__right {
    display: inline-block;
    color: #151f26;
    font-size: 0.95em;
    line-height: 1.35;
    letter-spacing: -0.2pt;
  }

  .content__right:hover {
    text-decoration: underline;
  }
}
</style>
